// Import model
import { SelectionBin } from '../models/SelectionBin';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { RoomSelection } from '../models/RoomSelection';

// Import dependency serializers (for complex types)
import { RoomSelectionSerializer } from './RoomSelectionSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SelectionBin - handles JSON serialization and deserialization with type validation
 */
export class SelectionBinSerializer {
  /**
   * Deserializes a JSON string into a SelectionBin instance
   */
  static deserialize(json: string): SelectionBin {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SelectionBin instance
   */
  static fromObject(obj: any): SelectionBin {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SelectionBin');
    }


    const instance: SelectionBin = {
      description: obj['description'] as string | undefined,
      itemIds: obj['itemIds'] ? (obj['itemIds'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      name: obj['name'] as string | undefined,
      roomSelection: obj['roomSelection'] ? RoomSelectionSerializer.fromObject(obj['roomSelection']) : undefined as any,
      rooms: obj['rooms'] ? (obj['rooms'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SelectionBin instances
   */
  static deserializeArray(json: string): SelectionBin[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SelectionBin instance to a JSON string
   */
  static serialize(instance: SelectionBin): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SelectionBin instance to a plain object
   */
  static toObject(instance: SelectionBin): any {
    return {
      'description': instance.description,
      'itemIds': instance.itemIds?.map((item: any) =>
        item
      ),
      'name': instance.name,
      'roomSelection': instance.roomSelection ? RoomSelectionSerializer.toObject(instance.roomSelection) : undefined,
      'rooms': instance.rooms?.map((item: any) =>
        item
      ),
    };
  }

  /**
   * Serializes an array of SelectionBin instances to a JSON string
   */
  static serializeArray(instances: SelectionBin[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
